import React from "react";
import { Spin } from "antd";
import {Container} from "./Styled";

type LandingProps = {
  children?: React.ReactNode;
};

const LandingPage: React.FunctionComponent<LandingProps> = ({ children })  => {
  return (
    <Container>
        <Spin wrapperClassName="LoaderSpin" size="large" spinning={true} delay={100}>
            {children}
        </Spin>
    </Container>
  );
};

export default LandingPage; 